@if (!field().hidden) {
<div
  class="form-control-container"
  [ngClass]="field().cssClases"
  [class.zn-modified]="showModified"
  [formGroup]="form()">
  <label
    class="form-label"
    [title]="field().label | abpLocalization"
    [class.d-block]="field().controlType === 'radio'"
    [class.form-check-label]="field().controlType === 'checkbox'"
    [attr.for]="field().key" >
    {{ field().label | abpLocalization }} @if(field().required) {
    <span class="form-label-required">*</span>
    }
    @if (showModified) {
    <small class="form-label-modified">
      {{ languageServiceResource + '::FieldModified' | abpLocalization }}
    </small>
    }
  </label>
  @switch (field().controlType) { 
  @case ('textbox') {
    <input
      class="form-control"
      [formControlName]="field().key"
      [id]="field().key"
      [type]="field().type"
      [attr.step]="field().step"
      [attr.maxlength]="getMaxLength(field())"
      [value]="field().value"
      [readonly]="field().readOnly"
      (blur)="trimValue()"
      (keydown)="onKeyDown($event)"
      [ngClass]="{
            'is-valid': valid && (isTouched || isDirty),
            'is-invalid': invalid && (isTouched || isDirty)
        }"
    />
  } @case ('checkbox') {
  <div class="form-check-inner-container">
    <input
      class="form-check-input check-lg order-first"
      [formControlName]="field().key"
      [id]="field().key"
      [type]="field().type"
      [checked]="checked()"
      (click)="toggle()"
      [ngClass]="{
              'is-valid': valid && (isTouched || isDirty),
              'is-invalid': invalid && (isTouched || isDirty)
          }"
    />
  </div>
  } @case ('datebox') {
  <div *ngIf="isDateTimeMode; else dateOnly">
    <div class="d-flex gap-2 align-items-start">
      <!-- datepicker -->
      <div class="flex-grow-1">
        <input
          class="form-control"
          [ngClass]="{
            'is-valid': valid && (isTouched || isDirty),
            'is-invalid': invalid && (isTouched || isDirty)
          }"
          ngbDatepicker
          #d="ngbDatepicker"
          #dateInput
          appDateMask
          [ngModel]="ngbDateValue()"
          (ngModelChange)="onDateChange($event)"
          [ngModelOptions]="{standalone: true}"
          (dateSelect)="onDateSelect($event)"
          [id]="field()?.key + '_date'"
          (mousedown)="$event.stopPropagation()"          
          (click)="$event.stopPropagation(); d.open()"     
          (blur)="onDateBlur(dateInput)"
          [readonly]="field().readOnly"
          [disabled]="field().readOnly"
          placeholder="dd/mm/yyyy"
          tabindex="0"
        />
      </div>

      <!-- time input -->
      <div style="width:120px">
        <input
          type="time"
          class="form-control"
          pattern="^([01]\d|2[0-3]):[0-5]\d$"
          [ngClass]="{
            'is-valid': valid && (isTouched || isDirty),
            'is-invalid': invalid && (isTouched || isDirty)
          }"
          [ngModel]="timeValue()"
          (ngModelChange)="onTimeChange($event)"
          [ngModelOptions]="{ standalone: true }"
          [id]="field()?.key + '_time'"
          (mousedown)="$event.stopPropagation()"       
          (click)="$event.stopPropagation()"       
          [readonly]="field().readOnly"
          [disabled]="field().readOnly"
          (blur)="markAsTouched()"
          tabindex="0"
        />
      </div>
    </div>
  </div>

  <!-- Legacy (date-only) -->
  <ng-template #dateOnly>
    <input
      class="form-control"
      [ngClass]="{
        'is-valid': valid && (isTouched || isDirty),
        'is-invalid': invalid && (isTouched || isDirty)
      }"
      ngbDatepicker
      #d="ngbDatepicker"
      #dateInput
      appDateMask
      [ngModel]="ngbDateValue()"
      (ngModelChange)="onDateChange($event)"
      [ngModelOptions]="{standalone: true}"
      (dateSelect)="onDateSelect($event)"
      [id]="field().key"
      (click)="$event.stopPropagation(); d.toggle()"
      (blur)="onDateBlur(dateInput)"
      [readonly]="field().readOnly"
      [disabled]="field().readOnly"
      placeholder="dd/mm/yyyy"
      tabindex="0"
      />
    </ng-template>
  } @case('timebox') {
  <input
    type="time"
    class="form-control"
    pattern="^([01]\d|2[0-3]):[0-5]\d$"
    [ngClass]="{
      'is-valid': valid && (isTouched || isDirty),
      'is-invalid': invalid && (isTouched || isDirty)
    }"
    [ngModel]="timeValue()"
    (ngModelChange)="onTimeChange($event)"
    [ngModelOptions]="{ standalone: true }"
    [id]="field().key"
    [readonly]="field().readOnly"
    [disabled]="field().readOnly"
    (blur)="markAsTouched()"
  />
  } @case ('dropdown') {
    <zn-single-select
      [options]="field().options"
      [optionsLoader]="dropdownOptionsLoader()"
      [showSearch]="true"
      [formControlName]="field().key"
      [errorEntityKey]="field().label"
      [localizationResource]="languageServiceResource"
      [openUp]="openUp()"
      [ngClass]="{
        'is-valid': valid && (isTouched || isDirty),
        'is-invalid': invalid && (isTouched || isDirty)
      }"
    ></zn-single-select>
  } @case ('radio') { @for (item of field().options; track item.value) {
  <div class="form-check form-check-inline">
    <input
      class="form-check-input"
      [id]="item.key"
      type="radio"
      [formControlName]="field().key"
      [value]="item.value"
    />
    <label class="form-check-label" [for]="item.key" [title]="item.key"
      >{{ item.key }}</label
    >
  </div>
  } } @case ('textarea') {
    <textarea
      class="form-control"
      [formControlName]="field().key"
      [rows]="field().rows || 3"
      [attr.maxlength]="getMaxLength(field())"
      [value]="field().value"
      [readonly]="field().readOnly"
      (blur)="trimValue()"
      [ngClass]="{
        'is-valid': valid && (isTouched || isDirty),
        'is-invalid': invalid && (isTouched || isDirty)
      }"
    ></textarea>
  } } @if (visibleErrors().length > 0)
    { @for (error of visibleErrors(); track $index) {
  <small class="invalid-feedback" [class.d-block]="invalid && (isTouched || isDirty)"
    >{{languageServiceResource + '::' + error.message | abpLocalization:
    error.value}}</small
  >
  } }
</div>
}
